// frontend/src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses (expired/invalid token)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/api/auth/login', { email, password });
export const getMe = () => api.get('/api/auth/me');
export const getUsers = () => api.get('/api/auth/users');
export const createUser = (data) => api.post('/api/auth/users', data);
export const updateUser = (id, data) => api.put(`/api/auth/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/api/auth/users/${id}`);

// Topics
export const getTopics = () => api.get('/api/topics');
export const getTopic = (id) => api.get(`/api/topics/${id}`);
export const createTopic = (data) => api.post('/api/topics', data);
export const updateTopic = (id, data) => api.put(`/api/topics/${id}`, data);
export const deleteTopic = (id) => api.delete(`/api/topics/${id}`);

// Runs
export const triggerRun = (data) => api.post('/api/runs', data);
export const getRuns = (params) => api.get('/api/runs', { params });
export const getRun = (id) => api.get(`/api/runs/${id}`);
export const getRunStats = () => api.get('/api/runs/stats');

// Content
export const getContent = (params) => api.get('/api/content', { params });
export const getContentItem = (id) => api.get(`/api/content/${id}`);
export const updateContent = (id, data) => api.put(`/api/content/${id}`, data);
export const deleteContent = (id) => api.delete(`/api/content/${id}`);
export const regenerateContent = (id, data) => api.post(`/api/content/${id}/regenerate`, data);

// Settings
export const getSettings = () => api.get('/api/settings');
export const updateSetting = (data) => api.put('/api/settings', data);
export const getScheduleConfig = () => api.get('/api/settings/schedule/config');
export const updateScheduleConfig = (data) => api.put('/api/settings/schedule/config', data);

// Brand Voice
export const getBrandVoices = () => api.get('/api/brand-voice');
export const getBrandVoice = (id) => api.get(`/api/brand-voice/${id}`);
export const createBrandVoice = (data) => api.post('/api/brand-voice', data);
export const updateBrandVoice = (id, data) => api.put(`/api/brand-voice/${id}`, data);
export const deleteBrandVoice = (id) => api.delete(`/api/brand-voice/${id}`);
export const extractBrandVoice = (id) => api.post(`/api/brand-voice/${id}/extract`);

export default api;
// RSS Feed Discovery
export const discoverRssFeeds = (domain) => api.post('/api/topics/rss-discover', { domain });
export const addRssFeed = (topicId, feedUrl) => api.post(`/api/topics/${topicId}/rss-feeds`, { feed_url: feedUrl });
export const removeRssFeed = (topicId, feedUrl) => api.delete(`/api/topics/${topicId}/rss-feeds`, { data: { feed_url: feedUrl } });
